import { render, staticRenderFns } from "./addScheduleClassesList.vue?vue&type=template&id=7ed99974&scoped=true"
import script from "./addScheduleClassesList.vue?vue&type=script&lang=js"
export * from "./addScheduleClassesList.vue?vue&type=script&lang=js"
import style0 from "./addScheduleClassesList.vue?vue&type=style&index=0&id=7ed99974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed99974",
  null
  
)

export default component.exports